// extracted by mini-css-extract-plugin
module.exports = {"hidden":"resultSubmit_hidden__zsaYY","textEmphasis":"resultSubmit_textEmphasis__MRF66","btnSubmit":"resultSubmit_btnSubmit__rISeL"};